import axios from 'axios';
import * as R from 'ramda';
import { requestWithAuthorization } from '@/appsync/lambda/requestWithAuthorization';
import portalConfigure from '@/portal-configure';

import { ErrorInfo, PreSignedUrlInfo } from '@/types/type';

export const generateUploadLink = async (
  tenant: string,
  landscape: string,
  file: File
) => {
  const response = await requestWithAuthorization
    .post(`${portalConfigure.API.generateUploadLink}`, {
      tenant,
      landscape,
      fileName: file.name,
    })
    .catch(error => {
      const data = R.path(['response', 'data'], error);
      if (data) {
        error.message = JSON.stringify(data);
      } else {
        const errorInfo: ErrorInfo = {
          code: 'E00007',
          title: 'Error in generating PreSigned URL.',
          message: error.message,
        };
        error.message = JSON.stringify(errorInfo);
      }
      throw error;
    });

  return response.data as PreSignedUrlInfo;
};

export const uploadFilesToIFXAP = async (
  tenant: string,
  landscape: string,
  objectKey: string,
  destination: string
) => {
  const response = await requestWithAuthorization
    .post(`${portalConfigure.API.uploadFilesToIFXAP}`, {
      tenant,
      landscape,
      objectKey,
      destination,
    })
    .catch(error => {
      const data = R.path(['response', 'data'], error);
      if (data) {
        error.message = JSON.stringify(data);
      } else {
        const errorInfo: ErrorInfo = {
          code: 'E00008',
          title: 'Error in uploading files to COMPANY V8.',
          message: error.message,
        };
        error.message = JSON.stringify(errorInfo);
      }
      throw error;
    });

  return response;
};

export const generateJobFileUploadLink = async (
  tenant: string,
  landscape: string,
  file: File
) => {
  const response = await requestWithAuthorization
    .post(`${portalConfigure.API.generateJobFileUploadLink}`, {
      tenant,
      landscape,
      fileName: file.name,
    })
    .catch(error => {
      const data = R.path(['response', 'data'], error);
      if (data) {
        error.message = JSON.stringify(data);
      } else {
        const errorInfo: ErrorInfo = {
          code: 'E00007',
          title: 'Error in generating PreSigned URL.',
          message: error.message,
        };
        error.message = JSON.stringify(errorInfo);
      }
      throw error;
    });

  return response.data as PreSignedUrlInfo;
};
